import { VscTypeHierarchySub } from "react-icons/vsc";
import { Link } from "react-router-dom";

export default function ManageMatrix() {
  return (
    <Link
      to={`/matrix`}
      className={`col-span-6 sm:col-span-4 lg:col-span-2  p-4 rounded-md  bg-blue-200 border border-blue-300`}
    >
      <div className="flex justify-between">
        <div className="flex flex-col justify-center items-center">
          <div className="flex items-center">
            <VscTypeHierarchySub color="#323232" size={24} />
            <div className="mx-2">Approval Matrix</div>
          </div>
        </div>
      </div>
    </Link>
  );
}
